import React from "react";
import Layout from "@/components/layout/Layout";
import cls from "@/components/page-modules/solutions/styles/Solutions.module.scss";
import { solutions } from "@/components/common/solutions";
import SolutionsTypeButton from "@/components/page-modules/solutions/components/SolutionsTypeButton";
import { useMediaQuery } from "react-responsive";
import { SolutionsMobileMenu } from "@/components/page-modules/solutions/components/SolutionsMobileMenu";
import { RelatedBlogs } from "@/components/page-modules/blog/shared/RelatedBlogs";
import SolutionHeader from "@/components/page-modules/solutions/components/SolutionHeader";
import SolutionItem from "@/components/page-modules/solutions/components/SolutionItem";
import { GetStaticProps, NextPage } from "next";
import { IBLog } from "@/components/page-modules/blog/data/blog.types";
import { ENDPOINTS } from "@/api/routing";
import axios from "axios";
import SmoothScrollStyle from "@/components/common/SmoothScrollStyle/SmoothScrollStyle";
import SeoHeader from "@/components/common/Seo/SeoHeader";
interface SolutionProps {
  blogData: IBLog[];
}
const Solution: NextPage<SolutionProps> = ({
  blogData
}) => {
  const isMobile = useMediaQuery({
    maxWidth: 550
  });
  return <Layout nav footer data-sentry-element="Layout" data-sentry-component="Solution" data-sentry-source-file="index.tsx">
      <SmoothScrollStyle data-sentry-element="SmoothScrollStyle" data-sentry-source-file="index.tsx" />
      <SeoHeader seoTitle="QR Code Solutions and Services" seoDescription="Unlock efficiency with our easily editable, trackable QR code solutions and services. Explore and elevate your business now!" noIndex={true} data-sentry-element="SeoHeader" data-sentry-source-file="index.tsx" />
      <div className={cls.main_container}>
        <SolutionHeader data-sentry-element="SolutionHeader" data-sentry-source-file="index.tsx" />
        {isMobile ? <SolutionsMobileMenu /> : <SolutionsTypeButton />}

        <div className={cls.solutions_container}>
          {solutions.map(item => {
          return <SolutionItem item={item} key={item.id} />;
        })}
        </div>
      </div>
      <div className={cls.related_blogs__container}>
        {blogData && <RelatedBlogs title="Related Articles" blogs={blogData} />}
      </div>
    </Layout>;
};
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  const response = await axios.get(ENDPOINTS.GET_TYPE_RELATED());
  const blogData = response.data.data;
  return {
    props: {
      blogData
    }
  };
};
export default Solution;